import { RefObject, useEffect, useState } from 'react';

/**
 * Hook to determine if an element is visible in the viewport.
 *
 * @param ref the ref of an element to observer
 * @param options [intersection observer options](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/IntersectionObserver)
 */
const useIsVisible = (ref: RefObject<HTMLElement | null>, options?: IntersectionObserverInit): boolean => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const intersectionObserver = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting), options);
    const element = ref.current;

    if (element) {
      intersectionObserver.observe(element);
    }

    return () => {
      if (element) {
        intersectionObserver.unobserve(element);
      }
      intersectionObserver.disconnect();
    };
  }, [options, ref]);

  return isVisible;
};

export default useIsVisible;
